import { render, staticRenderFns } from "./project-courses.vue?vue&type=template&id=b6d49856&"
import script from "./project-courses.vue?vue&type=script&lang=js&"
export * from "./project-courses.vue?vue&type=script&lang=js&"
import style0 from "./project-courses.vue?vue&type=style&index=0&id=b6d49856&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports